import { render, staticRenderFns } from "./transferForm.vue?vue&type=template&id=2088960a&scoped=true"
import script from "./transferForm.vue?vue&type=script&lang=js"
export * from "./transferForm.vue?vue&type=script&lang=js"
import style0 from "./transferForm.vue?vue&type=style&index=0&id=2088960a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088960a",
  null
  
)

export default component.exports